import IPricingFeature from 'models/IPricingFeature'

export interface PricingItemProps {
  planName: string
  cost: string
  description: string
  btnLabel: string
  icon: string
  features: IPricingFeature[]
  isFeatured?: boolean
  onSubscribeClick: () => void
}

export const usePricingItem = (props: PricingItemProps) => {
  return {
    ...props,
  }
}
